import { Type } from '@angular/core';
import { ActionsItemType } from '@libs/form/models';
import { SubmitGroupComponent } from './submit';

export type ActionsItemComponent = SubmitGroupComponent;

export const ActionItemsMap: Record<ActionsItemType, Type<ActionsItemComponent>> = {
  submit: SubmitGroupComponent,
};
